export default {
  name: '项目部署环境',
  test: ['https?://ma6(-|_)zuker.beijingapm.top'],
  BASE: 'https://center.beijingapm.top/', //MA通用接口
  ZUKER: 'https://ma-api.beijingapm.top/', //租客相关接口
  DATA: 'https://ma-api.beijingapm.top/', //首页统计接口
  FACE2FACE: 'https://ma-api.beijingapm.top/', //面对面接口
  APPORTION: 'https://ma-api.beijingapm.top/', //结算中心-券分摊应用接口
  TASK: 'https://ma-api.beijingapm.top/', //下载中心
  ACTIVITY: 'https://center.beijingapm.top',//活动管理相关
};
